export enum AssessmentState {
  NotAssessed = 'NotAssessed',
  Assessed = 'Assessed',
  InProgress = 'InProgress',
  ReAssessed = 'ReAssessed',
}
